import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowRandom = () => {
  return (
    <g>
      <path d="M8 3a.75.75 0 0 1 .102 1.494L8 4.501H4.25a.25.25 0 0 0-.243.193L4 4.75v7.746l1.277-1.285.08-.07a.712.712 0 0 1 .933.07c.252.254.277.65.076.932l-.076.09-2.533 2.554a.72.72 0 0 1-.127.102l-.057.033-.09.038-.12.03-.107.009-.087-.005-.06-.01a.71.71 0 0 1-.182-.062l-.057-.032-.046-.033-.08-.07L.21 12.234a.727.727 0 0 1 0-1.022.712.712 0 0 1 .933-.07l.08.07L2.5 12.499V4.751a1.75 1.75 0 0 1 1.606-1.744L4.25 3H8zm4.772-2 .09.009.122.03.089.038.057.033.065.046.062.056 2.533 2.554.076.09a.727.727 0 0 1-.076.932.712.712 0 0 1-.835.132l-.098-.062-.08-.07L13.5 3.501v7.744a1.75 1.75 0 0 1-1.606 1.744l-.144.006H8a.75.75 0 0 1-.102-1.493L8 11.495h3.75a.25.25 0 0 0 .243-.193l.007-.057V3.5l-1.277 1.288-.08.07a.712.712 0 0 1-.933-.07.727.727 0 0 1-.076-.932l.076-.09 2.533-2.554.08-.07.047-.033.057-.032.09-.038.091-.025.052-.008.112-.006zM10 7.25a.75.75 0 0 1 .102 1.493L10 8.75H6a.75.75 0 0 1-.102-1.493L6 7.25h4z" />
    </g>
  );
};

export default withIcon(IconArrowRandom);
